import React from 'react'
import { DisplayFieldContent } from './styled'

export default class DisplayField extends React.Component {
  render() {
    const { label, value } = this.props
    return (
      <DisplayFieldContent>
        <div className='labelText'>{label}</div>
        <div className='valueText'>{value}</div>
      </DisplayFieldContent>
    )
  }
}